import type { SearchCriteria } from "@/components/Filters"

export function toSearchSyntax(formdata: FormData) {
  const result = {} as Partial<Record<string, string>>

  for (const key of formdata.keys()) {
    const valueKey = key.replace(/Criteria$/, "")

    if (key.endsWith("Criteria") && formdata.has(valueKey)) {
      const value = formdata.get(valueKey)

      if (value == null || value === "") {
        result[valueKey] = undefined
        continue
      }

      const criteria = formdata.get(key) as SearchCriteria

      result[valueKey] = [
        criteria === "Ends With" || criteria === "Contains" ? "*" : "",
        (value as string).trim(),
        criteria === "Starts With" || criteria === "Contains" ? "*" : "",
      ].join("")

      continue
    }

    if (!(key in result)) {
      result[key] = (formdata.get(key) ?? undefined) as string | undefined
    }
  }

  return result
}
